import { ArrowUpRight } from "lucide-react";
import { Reveal, Overline } from "./Reveal";
import { SERVICES, prefillService } from "@/lib/site-data";

const SPANS = [
  "md:col-span-7 md:row-span-2 h-[420px] md:h-[560px]",
  "md:col-span-5 h-[420px] md:h-[268px]",
  "md:col-span-5 h-[380px] md:h-[268px]",
  "md:col-span-4 h-[380px]",
  "md:col-span-4 h-[380px]",
  "md:col-span-4 h-[380px]",
  "md:col-span-12 h-[360px]",
];

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="py-28 md:py-36">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <Reveal>
          <Overline>01 — What We Do</Overline>
          <div className="flex flex-wrap items-end justify-between gap-6 mb-14">
            <h2 className="font-display text-4xl md:text-5xl font-semibold tracking-tight">
              Solutions Built to Last.
            </h2>
            <p className="max-w-md text-gray-400 text-base">
              Waterproofing, foundations, and concrete — handled by one crew, done right the first time.
            </p>
          </div>
        </Reveal>

        <div className="grid md:grid-cols-12 gap-5">
          {SERVICES.map((s, i) => (
            <Reveal key={s.id} delay={0.06 * (i % 3)} className={SPANS[i]}>
              <article
                data-testid={`service-card-${s.id}`}
                className="group relative h-full w-full overflow-hidden rounded-2xl border border-white/10 bg-[#111]"
              >
                <img
                  src={s.img}
                  alt={s.title}
                  loading="lazy"
                  className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.06]"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/95 via-black/45 to-black/10 transition-opacity duration-500" />
                <div className="absolute top-0 left-0 h-[3px] w-0 bg-gradient-to-r from-[#00E5FF] to-[#0066FF] transition-[width] duration-500 group-hover:w-full" />
                <div className="absolute inset-x-0 bottom-0 p-6 md:p-7">
                  <span className="font-display text-sm font-semibold text-cyan-400 tracking-widest">{s.num}</span>
                  <h3 className="font-display text-2xl md:text-[1.7rem] font-semibold mt-1">{s.title}</h3>
                  <p className="mt-2 text-sm text-gray-400 max-w-md leading-relaxed">{s.desc}</p>
                  <a
                    href="#estimate"
                    data-testid={`service-learn-more-${s.id}`}
                    onClick={() => prefillService(s.title)}
                    className="mt-4 inline-flex items-center gap-1.5 text-sm font-bold text-cyan-400 link-underline"
                  >
                    Learn More <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                  </a>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
